import { Select, SelectItem, Stack, Text } from "@skailer-com/uikit";
import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface ImportDataUpdateBehaviorFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  options: SelectItem[];
}

export function ImportDataUpdateBehaviorField<T extends FieldValues>({
  control,
  name,
  options,
}: ImportDataUpdateBehaviorFieldProps<T>) {
  const { t } = useTranslation();

  return (
    <Stack direction="horizontal" gap="sm" items="center">
      <Text>{t("import_data:update_as").toLowerCase()}</Text>
      <Controller
        control={control}
        name={name}
        render={({ field: { value, onChange } }) => (
          <Select
            value={value}
            onChange={onChange}
            options={options}
            emptyTitle={t("common:select")}
            variant="button"
          />
        )}
      />
    </Stack>
  );
}
